import React,{useState,useEffect} from "react";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Dropdown, DropdownButton, ButtonGroup } from "react-bootstrap";
import Modal from 'react-bootstrap/Modal';
import AuthUser from "../AuthUser";
export default (props) => {
  const{http,getUser}=AuthUser()
  let userdetails = getUser()
  const{data,refreshData,actionurl,updateStatus}=props;
  const [modalshow, setModalshow] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedid, setSelectedid] = useState(null);
  const handleShowModal = (id) => {
      setSelectedid(id);
      setShowModal(true);
  };

  const handleCloseModal = () => {
      setSelectedid(null);
      setShowModal(false);
  };
  const handleDelete = () =>{
    if(selectedid != ''){
      http.post(`/agent/${actionurl}/${userdetails.email}`,{id:selectedid})
      .then((response) => {
          //console.log(response); 
          refreshData();
          handleCloseModal();             
      })
      .catch(function (error) {
          // handle error
          console.log(error.response.data.error);
      });
    }
    
  }
  const handleStatus = (id,status) =>{
    console.log("Status",status)
    if(status == 'Y'){

    }else{
      
    }
    http.get(`/admin/${updateStatus}/${userdetails.email}?id=${id}&status=${status}`)
    .then((response) => {
      refreshData();      
    })
    .catch(function (error){

    })
  }
  return (
    <>
      <DropdownButton
      as={ButtonGroup}
      size="sm"
      autoClose="outside"
      variant="muted"
      style={{ maxHeight: "28px" }}
      title={
        <span>
          <i class="bi bi-three-dots"></i>
        </span>
      }
    >
      <Dropdown.Item href="#" onClick={()=>handleShowModal(data.id)}>Delete</Dropdown.Item>
      <Dropdown.Item href="#" onClick={(e) => e.stopPropagation()}>
        <Row>
          <Col sm={8}>Activate</Col>
          <Col sm={4} className="pt-2">
            <div onClick={(e) => e.stopPropagation()}>
              <Form.Check type="switch" name="statusY" checked={data.status == 'Y'} onChange={() => handleStatus(data.id, data.status === 'Y' ? 'N' : 'Y')} disabled={data.status === 'Y'} id="Activate-switch" />
            </div>
          </Col>
        </Row>
      </Dropdown.Item>
      <Dropdown.Item href="#" onClick={(e) => e.stopPropagation()}>
        <Row>
          <Col sm={8}>Deactivate</Col>
          <Col sm={4} className="pt-2" style={{ zIndex: "9999" }}>
            <div onClick={(e) => e.stopPropagation()}>
            <Form.Check type="switch" name="statusN" checked={data.status == 'N'} onChange={() => handleStatus(data.id, data.status === 'N' ? 'Y' : 'N')} disabled={data.status === 'N'} id="Deactivate-switch" />
            </div>
            
          </Col>
        </Row>
      </Dropdown.Item>
    </DropdownButton>
    <Modal size="md" aria-labelledby="contained-modal-title-vcenter" show={showModal} onHide={handleCloseModal} centered>
    <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Delete</Modal.Title>
    </Modal.Header>
    <Modal.Body>                
        <div className="input_fields_wrap">
            <div className="mb-2 col-md-12">
                <p style={{ color: '#2D8BB4' }}><strong>Are you sure you want to delete ?</strong></p>
            </div>
        </div>
    </Modal.Body>
    <Modal.Footer>
        <div className="mb-2 col-md-12 text-center">
            <button type="button" className="btn btn-secondary ml-2" onClick={handleCloseModal}>No</button> 
            <button type="submit" onClick={handleDelete} className="btn btn-primary ml-2">Yes</button>
        </div>
    </Modal.Footer>
</Modal>

    </>
  );
};
